import { jsx as _jsx } from "react/jsx-runtime";
import { PlugZap } from 'lucide-react';
import { Card } from './card.js';
import { EmptyState } from './empty-state.js';
/** «A», «A и B», «A, B и C». */
function joinRu(items) {
    if (items.length <= 1)
        return items.join('');
    return `${items.slice(0, -1).join(', ')} и ${items[items.length - 1]}`;
}
/**
 * Фраза «сервис не подключён: задайте ENV в приложении» — та же, что в
 * `NotConfiguredState`; экспортирована для карт ошибок, где 503
 * `*_not_configured` описывается тем же текстом в toast/`ErrorCard`.
 */
export function notConfiguredText(service, envVars, app = 'admin-api') {
    return `${service} не подключён: задайте ${joinRu(envVars)} в ${app}`;
}
/**
 * Экран «интеграция не подключена»: вместо пяти одинаковых ошибок 503 —
 * одна понятная фраза, что именно задать в env. Состояние, а не ошибка:
 * сервис просто не настроен на этом стенде.
 */
export function NotConfiguredState({ service, envVars, app }) {
    return (_jsx(Card, { children: _jsx(EmptyState, { icon: PlugZap, title: `${service} не подключён`, description: notConfiguredText(service, envVars, app) }) }));
}
//# sourceMappingURL=not-configured-state.js.map